export default __webpack_public_path__ + "static/media/martijn-cutout.33de1c9e.png";